import { render, staticRenderFns } from "./TachoEvents.vue?vue&type=template&id=2f08ac63&scoped=true"
import script from "./TachoEvents.vue?vue&type=script&lang=js"
export * from "./TachoEvents.vue?vue&type=script&lang=js"
import style0 from "./TachoEvents.vue?vue&type=style&index=0&id=2f08ac63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f08ac63",
  null
  
)

export default component.exports